/** Permissions minimales pour émettre une facture en autonomie (sans SUBMIT/APPROVE). */
export const NR2J_INVOICE_AUTONOMY_BUNDLE = Object.freeze([
  'NR2J_INVOICES_VIEW',
  'NR2J_INVOICES_CREATE',
  'NR2J_INVOICES_EDIT',
  'NR2J_INVOICES_ISSUE_WITHOUT_APPROVAL',
]);

/**
 * Active le bundle émission autonome.
 * À la désactivation : retire uniquement ISSUE_WITHOUT_APPROVAL
 * (ne retire pas VIEW/CREATE/EDIT éventuellement attribués séparément).
 */
export function applyInvoiceAutonomyToggle(checkedCodes, enabling) {
  const next = new Set(checkedCodes || []);
  if (enabling) {
    for (const code of NR2J_INVOICE_AUTONOMY_BUNDLE) next.add(code);
  } else {
    next.delete('NR2J_INVOICES_ISSUE_WITHOUT_APPROVAL');
  }
  return [...next];
}

export function buildPermissionOverrides(templateCodes, checkedCodes) {
  const template = new Set(templateCodes || []);
  const checked = new Set(checkedCodes || []);
  const overrides = [];
  const universe = new Set([...template, ...checked]);
  for (const permissionCode of universe) {
    const inTemplate = template.has(permissionCode);
    const on = checked.has(permissionCode);
    if (on && !inTemplate) overrides.push({ permissionCode, allowed: true });
    if (!on && inTemplate) overrides.push({ permissionCode, allowed: false });
  }
  overrides.sort((a, b) => a.permissionCode.localeCompare(b.permissionCode));
  return overrides;
}

export function describePermissionState(code, templateCodes, checkedCodes) {
  const inTemplate = (templateCodes || []).includes(code);
  const on = (checkedCodes || []).includes(code);
  if (on && inTemplate) return 'inherited';
  if (on && !inTemplate) return 'added';
  if (!on && inTemplate) return 'removed';
  return 'absent';
}

export function effectiveFromProfile(templateCodes, overrides) {
  const effective = new Set(templateCodes || []);
  for (const row of overrides || []) {
    if (row.allowed) effective.add(row.permissionCode);
    else effective.delete(row.permissionCode);
  }
  return [...effective];
}
